/**
 * Liste tablolarının çerçeve yüksekliğini ölçerek ayarlar.
 *
 * Yükseklik önceden `calc(100vh - 190px)` ile varsayılıyordu; üst alanı daha
 * kalabalık ekranlarda tablo ekrana sığmıyor, tablo yerine sayfa kayıyordu.
 *
 * Ölçüm kartın kendi üzerinden yapılır: çerçevenin altında kalan boşluk
 * (sayfalama şeridi ve kart dolgusu) kart alt kenarı ile çerçeve alt kenarı
 * arasındaki farktır. Bu fark çerçevenin yüksekliğinden bağımsızdır; sayfa
 * yüksekliği üzerinden ölçmek ise her geçişte çerçeveyi biraz daha kısaltan
 * bir geri besleme yaratıyordu (yakınlaştırma sonrası tablo küçülüp kalıyordu).
 */
const EN_AZ_YUKSEKLIK = 260
const ALT_BOSLUK = 12

const ayarla = () => {
    const kapsayicilar = document.querySelectorAll<HTMLElement>('.new-table-container')

    kapsayicilar.forEach((kapsayici) => {
        const olcu = kapsayici.getBoundingClientRect()

        // Çerçevenin altında kalan öğeler (sayfalama şeridi, kart dolgusu).
        const kart = kapsayici.closest('.card') as HTMLElement | null
        const kartAlt = kart ? kart.getBoundingClientRect().bottom : olcu.bottom
        const altKalan = Math.max(0, kartAlt - olcu.bottom)

        // Sayfa kaydırılmışsa çerçevenin belge üzerindeki gerçek başlangıcı kullanılır.
        const ustNokta = olcu.top + window.scrollY

        const kalan = window.innerHeight - ustNokta - altKalan - ALT_BOSLUK
        const yukseklik = Math.max(EN_AZ_YUKSEKLIK, Math.round(kalan))

        if (kapsayici.style.height !== yukseklik + 'px')
            kapsayici.style.height = yukseklik + 'px'
    })
}

let bekleyen = 0

const planla = () => {
    if (bekleyen)
        return

    bekleyen = window.requestAnimationFrame(() => {
        bekleyen = 0
        ayarla()
    })
}

/**
 * Uygulama açılışında bir kez çağrılır. Pencere boyutu değiştiğinde
 * (yakınlaştırma ve başka ekrana taşıma dahil), ekran değiştiğinde ve filtre
 * paneli gibi alanlar açılıp kapandığında yeniden ölçer.
 */
export const startListTableHeightWatcher = () => {
    planla()

    window.addEventListener('resize', planla)
    window.addEventListener('orientationchange', planla)

    // Yakınlaştırma bazı tarayıcılarda pencere olayı üretmez; gövde boyutu izlenir.
    const boyutGozlemcisi = new ResizeObserver(planla)
    boyutGozlemcisi.observe(document.body)

    // Ekran değişimi, filtre panelinin açılması gibi düzen değişiklikleri.
    const icerikGozlemcisi = new MutationObserver(planla)
    icerikGozlemcisi.observe(document.body, { childList: true, subtree: true })

    return () => {
        window.removeEventListener('resize', planla)
        window.removeEventListener('orientationchange', planla)
        boyutGozlemcisi.disconnect()
        icerikGozlemcisi.disconnect()
    }
}
